import Vue from 'vue'

import 'normalize.css/normalize.css' //  A modern alternative to CSS resets

import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/zh-CN' //  lang i18n
import { Affix } from 'ant-design-vue'
import 'element-ui/lib/theme-chalk/index.css'
import VueAMap from 'vue-amap'
import VueTagTextarea from 'vue-tag-textarea'
import 'vue-tag-textarea/lib/vue-tag-textarea.css'
import '@/styles/index.scss' //  global css
import VueClipboard from 'vue-clipboard2'
// import '@/components/Tinymce/tinymce.js'
// import './regEleCom'
// import lang from 'element-ui/lib/locale/lang/en'
// import locale from 'element-ui/lib/locale'
// import regEleCom from './regEleCom'

import App from './App'
import store from './store'
import router from './router'

import '@/icons' //  icon
import '@/permission' //  permission control

import '@/assets/scss/index.scss'
/**
 * If you don't want to use mock-server
 * you want to use MockJs for mock api
 * you can execute: mockXHR()
 *
 * Currently MockJs will be used in the production environment,
 * please remove it before going online! ! !
 */
//   import { mockXHR } from '../mock'
//   if (process.env.NODE_ENV === 'production') {
//     mockXHR()
//   }

//   set ElementUI lang to EN
Vue.component(Affix.name, Affix)
Vue.use(ElementUI, { locale })
// Vue.use(regEleCom)
// locale.use(lang)
Vue.use(VueAMap)
Vue.use(VueClipboard)
VueAMap.initAMapApiLoader({
  // key: 'db365611afcefbe78cf2fd45032dc353',
  // key: 'a3a5c85f2c0913cdc48397a30a85b16f',
  // key: '8a3eb66f2cd32ca1daaa68c24da0f26f',
  key: '7cca22f2d4d9d9eb0bd16162b603764b', // Web端
  plugin: [
    'AMap.Autocomplete',
    'AMap.PlaceSearch',
    'AMap.Scale',
    'AMap.OverView',
    'AMap.ToolBar',
    'AMap.MapType',
    'AMap.PolyEditor',
    'AMap.CircleEditor',
    'AMap.Geolocation',
    'AMap.Geocoder',
    'AMap.AMapManager'
  ],
  v: '1.4.4'
})
Vue.use(VueTagTextarea)

Vue.config.productionTip = false

new Vue({
  // el: '#app',
  router,
  store,
  render: h => h(App)
}).$mount('#app')
